import { Link, useLocation } from "react-router-dom";
import { ArrowLeftRight } from "lucide-react";

export function VersionSwitch({ original = false }: { original?: boolean }) {
  const location = useLocation();
  let pathname = location.pathname.replace(/^\/v2(?=\/|$)/, "") || "/dashboard";
  // The classic journal has an edit screen, but no separate read-only detail route.
  if (
    original &&
    /^\/financial\/journal\/[^/]+$/.test(pathname) &&
    !pathname.endsWith("/new")
  )
    pathname += "/edit";
  const target = `${original ? "" : "/v2"}${pathname}${location.search}${location.hash}`;
  return (
    <Link
      to={target}
      className={
        original
          ? "v2-version-switch"
          : "inline-flex items-center gap-2 rounded-md border px-3 py-2 text-xs font-medium hover:bg-accent focus-visible:outline-2 focus-visible:outline-offset-2"
      }
      onClick={() => {
        try {
          localStorage.setItem(
            "travallis-interface",
            original ? "classic" : "v2",
          );
        } catch {
          /* Navigation still works without storage. */
        }
      }}
    >
      <ArrowLeftRight size={14} aria-hidden="true" />
      {original ? "Use original version" : "Try new workspace"}
    </Link>
  );
}
